window.addEventListener('DOMContentLoaded', () => {

    // Mega menu link rposition
    function resizeGridItem(item){  
        let grid = item.closest(".megamenu-links-container");
        let rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
        let rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
        let rowSpan = Math.ceil((item.querySelector('.megamenu-content').offsetHeight+rowGap)/(rowHeight+rowGap));
        item.style.gridRowEnd = "span "+rowSpan;
    }

    function megaMenuReposition(elem) {

        let allItems = elem.querySelectorAll(".grid__item");
        for(let x=0;x<allItems.length;x++){
            resizeGridItem(allItems[x]);
        }

    }

    const megaMenus = document.querySelectorAll('.megamenu');

    if(megaMenus.length) {

        megaMenus.forEach(menu => {
            const itemsToReposotion = menu.querySelectorAll('.menu-links-2-cols');
            if(itemsToReposotion.length) {
                menu.addEventListener('mouseover', function() {
                    megaMenuReposition(menu);
                })

            }
            
        });

    }

    // Collection filter drawer
    const toggleFilterBtns = document.querySelectorAll('.js-toggle-filter-drawer');
    if(toggleFilterBtns.length) {
        toggleFilterBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                const filterDrawer = document.querySelector('.filter-drawer');
                filterDrawer.classList.toggle('open');
            })
        })
    }
});

class ProductGridSlideshow extends HTMLElement {
    constructor() {
        super();

        const slider = this.querySelector('[data-slider]');
        if (!slider) return;

        const isRecommendations = this.dataset.isRecommendations;

        if(isRecommendations == "true") {
            setTimeout(() => {
                this.initSlider(slider);
            },200);
        } else {
            this.initSlider(slider);
        }
    }

    initSlider(slider) {
        const flkty = new Flickity(slider, {
            wrapAround: true,
            pageDots: false,
            imagesLoaded: true,
            lazyLoad: 1,
            adaptiveHeight: true,
            draggable: false,
            arrowShape: "M95,48H9.83L41,16.86A2,2,0,0,0,38.14,14L3.59,48.58a1.79,1.79,0,0,0-.25.31,1.19,1.19,0,0,0-.09.15l-.1.2-.06.2a.84.84,0,0,0,0,.17,2,2,0,0,0,0,.78.84.84,0,0,0,0,.17l.06.2.1.2a1.19,1.19,0,0,0,.09.15,1.79,1.79,0,0,0,.25.31L38.14,86A2,2,0,0,0,41,86a2,2,0,0,0,0-2.83L9.83,52H95a2,2,0,0,0,0-4Z",
            on: {
                ready: function() {
                this.resize();
                }
            }
            });
            flkty.resize();
    
            const observer = new IntersectionObserver(([ entry ], observer) => {
            if (entry.isIntersecting) {
                flkty.resize();
            }
            }, {rootMargin: '0px', threshold: 1.0});
    
            observer.observe(slider);
    }
}

customElements.define('product-grid-slideshow', ProductGridSlideshow);

$(document).on('click', 'product-grid-slideshow .flickity-prev-next-button', (e) => {e.preventDefault()});

$(document).ready(function(){
    if ($(window).width() < 768){
        $('.mobile-slider').flickity({
            wrapAround: true,
            pageDots: true,
            initialIndex: 0,
            draggable: true
        });

        const mobileStickyMenu = document.querySelector('.mobile-sticky-menu');
        if(mobileStickyMenu) {
            const height = mobileStickyMenu.offsetHeight;
            document.querySelector("body").style.marginBottom = `${height}px`;
        }
    }
});
